import CheckBox from '@components/std-components/CheckBox'
import React, { FC } from 'react'
import * as css from './ListItem.css'

export interface ListItemProps {
  index?: number
  isSelected: boolean
  option: string
  onSelect: () => void
  onDeselect: () => void
  disabled?: boolean
}

const ListItem: FC<ListItemProps> = ({
  isSelected,
  option,
  onSelect,
  onDeselect,
  disabled
}) => {
  return (
    <CheckBox
      checked={isSelected}
      checkBoxClick={() => {
        isSelected ? onDeselect() : onSelect()
      }}
      id={option}
      name={option}
      label={option}
      variant='checkboxlabel'
      classes={css.checkboxLabel}
      disabled={disabled}
    />
  )
}

export default ListItem
